import COMMON_TYPES from '../../../actions/types';
import * as analytics from '../../../analytics';
import { showNotificationLayer } from '../../../actions/notification';
import { createObject, deleteObject } from '../../../api/object';
import { saveArchiveLegislativeProcess, deleteArchiveLegislativeProcess } from '../../../api/legislative-processes';
import { formatDataFormArchive } from '../utils';
import { details } from '../../../api/common';

const loadingPost = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const deleteFile = ({ formParams }) => {
  const { id, legislativeProcesseId, key } = formParams;

  return async dispatch => {
    try {
      await Promise.all([
        deleteArchiveLegislativeProcess({ id, legislativeProcesseId }),
        deleteObject({ key })
      ]);
    }
    catch (responseFail) {
      return dispatch({
        type: COMMON_TYPES.formPostResultError,
        payload: responseFail.response.data,
      });
    }
  }
}

export const uploadFile = ({ formParams }) => {
  return dispatch => {
    dispatch(loadingPost());

    createObject(formParams.fileStream)
      .then(response => {
        const { id } = formParams;
        const { name, url } = response.data;

        saveArchiveLegislativeProcess({
          id,
          name,
          url,
        })
          .then(() => {
            dispatch(toggleFormCreateArchiveLayer());

            dispatch(
              showNotificationLayer('O arquivo foi salvo no documento!')
            );
          })
          .catch(responseFail => {
            dispatch(loadingPost());

            dispatch({
              type: COMMON_TYPES.formPostResultError,
              payload: responseFail.response
            });
          });
      })
      .catch(responseFail => {
        dispatch(loadingPost());
        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data
        });
      });
  }
}

export const toggleFormCreateArchiveLayer = params => {
  if(params && params.id) {
    analytics.registerEvent({
      category: analytics.categories.legislative,
      action: analytics.actions.legislativeArchive,
    });

    return dispatch => {
      dispatch([
        {
          type: COMMON_TYPES.toggleLayer,
          payload: 'createArchive',
        },
        { type: COMMON_TYPES.formGetWatingResponse, payload: true },
      ]);

      details({ id: params.id, path: 'legislative.processe.php' })
        .then(({ data }) => {
          dispatch([{
              type: COMMON_TYPES.formInitializeValues,
              payload: formatDataFormArchive(data),
            },
            { type: COMMON_TYPES.formGetWatingResponse, payload: false },
          ])
        })
        .catch((e) =>
          dispatch({ type: COMMON_TYPES.formGetResultError })
        )
    }
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
